// SortHeader — clickable table header cell with sort indicator.
//
// Click toggles the sort direction; clicking a different column resets
// to descending (the natural default for score/Δ4w/last-seen) or
// ascending (for name-like columns) via the `initialDir` prop.
//
// Keeps focus and aria-sort state consistent so screen-readers and
// keyboard users can navigate the column ordering.

import React from "react";

const SortHeader = ({ label, sortKey, currentKey, currentDir, onSort, initialDir = "desc", className = "" }) => {
    const isActive = currentKey === sortKey;
    const ariaSort = isActive ? (currentDir === "asc" ? "ascending" : "descending") : "none";
    const indicator = isActive ? (currentDir === "asc" ? "\u2191" : "\u2193") : "";
    const handle = () => {
        if (!isActive) return onSort(sortKey, initialDir);
        onSort(sortKey, currentDir === "asc" ? "desc" : "asc");
    };
    return (
        <th
            scope="col"
            aria-sort={ariaSort}
            className={`text-left py-2 font-medium ${className}`}
        >
            <button
                type="button"
                onClick={handle}
                data-testid={`workbench-sort-${sortKey}`}
                className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-medium hover:text-[hsl(var(--ink))] transition-colors ${isActive ? "text-[hsl(var(--ink))]" : "text-[hsl(var(--mute))]"}`}
            >
                <span>{label}</span>
                <span className="text-[10px] w-2 inline-block">{indicator}</span>
            </button>
        </th>
    );
};

export default SortHeader;
